export default "__VITE_ASSET__CBR00JJl__"